/* IMPORT ENTITIES AND RESOLVERS */
import { resolvers as AthenaResolvers } from './athena'

export const entities = [  
  /* ENTITIES */
] 


export const schema = {
  resolverClasses: [
    /* RESOLVER CLASSES */
		...AthenaResolvers,
  ] 
}
